import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "data-testid", "isTranslation", "linkTarget", "navItem", "selected"];
import React, { forwardRef } from 'react';
import { useTranslate } from '@im/react-localization';
import classNames from 'clsx';
import { styled } from '@mui/material/styles';
import MuiLink from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export function NavLink(props) {
  var classNameProp = props.className,
    _props$dataTestid = props['data-testid'],
    testidProp = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    _props$isTranslation = props.isTranslation,
    isTranslation = _props$isTranslation === void 0 ? true : _props$isTranslation,
    _props$linkTarget = props.linkTarget,
    linkTarget = _props$linkTarget === void 0 ? '_blank' : _props$linkTarget,
    navItem = props.navItem,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    others = _objectWithoutProperties(props, _excluded);
  var className = classNames({
    'NavLink-selected': selected
  }, classNameProp);
  var _navItem$color = navItem.color,
    color = _navItem$color === void 0 ? 'inherit' : _navItem$color,
    content = navItem.content,
    key = navItem.key,
    labelProp = navItem.label,
    _onClick = navItem.onClick,
    route = navItem.route,
    url = navItem.url;
  var testid = testidProp ? testidProp : key;
  var translate = useTranslate();
  var label = labelProp && isTranslation ? labelProp : translate(key);
  var children = content ? content : label;
  var LinkBehavior = /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/_jsx(RouterLink, _extends({
      ref: ref,
      to: route != null ? route : '/'
    }, props));
  });
  if (_onClick) {
    return /*#__PURE__*/_jsx(StyledMuiLink, _extends({
      "aria-label": label,
      className: className,
      color: color,
      "data-testid": "".concat(testid, "-OnClickNavItem"),
      href: "",
      onClick: function onClick(e) {
        _onClick(navItem);
        e.preventDefault();
      },
      selected: selected
    }, others, {
      children: children
    }));
  }
  if (route) {
    return /*#__PURE__*/_jsx(StyledMuiLink, _extends({
      "aria-label": label,
      className: className,
      color: color,
      component: LinkBehavior,
      "data-testid": "".concat(testid, "-RouteNavItem"),
      selected: selected
    }, others, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(StyledMuiLink, _extends({
    "aria-label": label,
    className: className,
    color: color,
    "data-testid": "".concat(testid, "-UrlNavItem"),
    href: url,
    rel: "noopener noreferrer",
    selected: selected,
    target: linkTarget
  }, others, {
    "data-element": "StyledMuiLink",
    "data-component": "NavLink",
    "data-source-file": "NavLink.tsx",
    children: children
  }));
}
var StyledMuiLink = styled(MuiLink)(function (_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    theme = _ref.theme;
  return {
    background: selected ? 'red' : undefined
  };
});